export const compareStrings = (a: string, b: string): number =>
  a < b ? -1 : a > b ? 1 : 0;

export const formatInt = (num: number | string | null | undefined): string => {
  if (num == null) {
    return '';
  } else if (typeof num === 'number') {
    return num.toLocaleString('en-GB', { maximumFractionDigits: 0 });
  } else {
    return parseInt(num).toLocaleString('en-GB', { maximumFractionDigits: 0 });
  }
};

export const formatPerc = (num: number | string | null | undefined): string => {
  if (num == null) {
    return '';
  } else if (typeof num === 'number') {
    return `${(num * 100).toLocaleString('en-GB', {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1,
    })}%`;
  } else {
    return `${(parseFloat(num) * 100).toLocaleString('en-GB', {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1,
    })}%`;
  }
};

export const formatDateTime = (date: Date): string => {
  return `${date.toLocaleDateString('en-ZA', { dateStyle: 'short' })} ${date.toLocaleTimeString('en-ZA', { timeStyle: 'short' })}`;
};

export const firstCap = (str: string): string =>
  str.charAt(0).toUpperCase() + str.substring(1);

export const normalizeCellNumber = (dirtyNumber: string): string => {
  const charClean = dirtyNumber.replace(/[^+0-9]/g, '');
  const match = /(0|27)(\d{9})/.exec(charClean);
  return match != null ? `0${match[2]}` : charClean;
};

export const formatPhone = (phone: string): string => {
  const match = /27(\d{2})(\d{3})(\d{4})/.exec(phone);
  if (match != null) {
    return `0${match[1]} ${match[2]} ${match[3]}`;
  } else {
    return `+${phone}`;
  }
};

export const formatId = (idnumber: string): string => {
  const match = /(\d{6})(\d{4})(\d{3})/.exec(idnumber);
  if (match != null) {
    return `${match[1]} ${match[2]} ${match[3]}`;
  } else {
    return idnumber;
  }
};

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  return String(error);
}
